@if (_active) {
  <kendo-window
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form-->
    <form novalidate
      [formGroup]="_form"
      (ngSubmit)="$event.preventDefault()"
      (keydown.enter)="$event.preventDefault()"
      class="form_style">
      <div class="row">
        <div class="col-12">
          <div class="transaction-section-header">
            <div class="transaction-section-header-title">
              Picklist
              <span class="statusSection">
                <span class="statusText">Status</span>
                <span>
                  <input type="radio"
                    formControlName="closed"
                    class="is-open"
                    kendoRadioButton
                    value="false" />
                    <label class="control-label statusLabel">Open </label>
                    <input #kendoRadioButtonInput
                      formControlName="closed"
                      type="radio"
                      class="is-closed"
                      kendoRadioButton
                      value="true" />
                      <label class="control-label statusLabel">Closed</label>
                    </span>
                  </span>
                </div>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if ((_pageState == 2 ||_pageState == 3)
                      && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li (click)="_onEditForms()"
                        >
                        Edit Forms
                      </li>
                    }
                    @if ((_pageState == 2 )
                      && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li class="wikiButton" (click)="_onEditFields()"
                        >
                        Edit Fields
                      </li>
                    }
                    @if (_pageState == 4) {
                      <li (click)="_returnAdNew()">
                        Close Edit Fields
                      </li>
                    }
                    @if (_pageState == 2 ) {
                      <li class="wikiButton" (click)="_viewInactiveFields()">
                        View Inactive Fields
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button type="button" kendoButton class="steps_buttons_class" (click)="_onCancel()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        @if (canAccess('pickList', 'create')) {
                          <button type="button"
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Copy</span>
                            </button>
                          }
                          @if (canAccess('pickList','create')) {
                            <button type="button"
                              kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndNew')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & New</span>
                              </button>
                            }
                            <button type="button"
                              kendoButton
                              class="steps_buttons_class"
                              (click)="_onSave('saveAndClose')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & Close</span>
                              </button>
                              <button type="button"
                                kendoButton
                                class="steps_buttons_class"
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('save')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save</span>
                                </button>
                              </div>
                            }
                          </div>
                          <!-- <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
                          <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
                        </button>
                        <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
                          <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
                        </button> -->
                      </div>
                    </div>
                  </div>
                  <div class="row no-row-margin">
                    <div class="col-12 col-lg-6 small-pad-right mb-2">
                      <div class="transactionWidget">
                        <div class="row">
                          <div class="col-12">
                            <p class="titleStandardStyle">General Information</p>
                          </div>
                          @if (_currentUser && _currentUser.isEnterprise) {
                            <div class="col-12"
                              >
                              <div class="form-group special_style_formgroup display-flex">
                                <div class="row flex-1">
                                  <div class="col-2">
                                    <label class="control-label">Account</label>
                                  </div>
                                  <div class="col-10 transaction-input-fields">
                                    <accounts-dropdown #kendo_combo_accounts
                                      [formControl]="_selectedAccount"
                                      class="bordered current-step newFormControlWidth"
                                      [class.active]="_selectedAccount.value == null"
                                      [required]="true">
                                    </accounts-dropdown>
                                  </div>
                                </div>
                                <div class="transactions-stock-right-checkbox empty"></div>
                              </div>
                            </div>
                          }
                          <sites-dropdown #kendo_combo_sites
                            layout="form-group"
                            [showAllSites]="true"
                            [labelText]="'Site'"
                            formControlName="site"
                            [placeholder]="'Choose a Site'"
                            [textField]="'name'"
                            [valueField]="'id'"
                            class="bordered current-step newFormControlWidth"
                            [required]="true">
                          </sites-dropdown>
                          @if (getAuthByLabel('LBL_PickListCode')?.canView) {
                            <div class="col-12 margin-top-10"
                              >
                              <div class="form-group special_style_formgroup display-flex">
                                <div class="row flex-1">
                                  <div class="col-2">
                                    <label class="control-label">
                                      {{getLabel('LBL_PickListCode')?.currentText}}
                                    </label>
                                  </div>
                                  <div class="col-10 transaction-input-fields">
                                    <input #kendo_transaction_code_input
                                      type="text"
                                      class="k-textbox writebox newFormControlWidth"
                                      [placeholder]="'Code'"
                                      formControlName="code"
                                      required
                                      (keyup.enter)="_barcodeSubmited()"
                                      (keydown.Tab)="_barcodeSubmited()"
                                      (focusout)="_barcodeSubmited()"
                                      [readOnly]="_pageState == 1"
                                      [attr.disabled]="getAuthByLabel('LBL_PickListCode')?.canEdit ? null : 'disabled'" />
                                      @if (_pageState!=1) {
                                        <a
                                          [class.editfieldsIconvisible]="_pageState !== 4"
                                          class="cursor-pointer"
                                          (click)="_generateBarcodeClick()">
                                          <img class="searchIcon"
                                            [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                          </a>
                                        }
                                        <a [class.editfieldsIconvisible]="_pageState == 4"
                                          class="editFieldsIcon"
                                          (click)="_openRenameForm('LBL_PickListCode', false)">
                                          <img class="searchIcon"
                                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                          </a>
                                        </div>
                                      </div>
                                      <div class="transactions-stock-right-checkbox">
                                        <!-- <input
                                        type="checkbox"
                                        class="k-checkbox"
                                        [formControl]="_autoCodeGeneration"
                                        kendoCheckBox
                                        /> -->
                                        <div class="transactions-stock-right-checkbox-text">
                                          <!-- Auto Generate -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (getAuthByLabel('LBL_PickListDescription')?.canView) {
                                  <div
                                    class="col-12">
                                    <div class="form-group special_style_formgroup display-flex">
                                      <div class="row flex-1">
                                        <div class="col-2">
                                          <label class="control-label">{{getLabel('LBL_PicklistDescription')?.currentText}}</label>
                                        </div>
                                        <div class="col-10 transaction-input-fields">
                                          <input #kendo_Input_Picklist_Description
                                            type="text"
                                            class="k-textbox writebox newFormControlWidth"
                                            placeholder="Description"
                                            formControlName="description"
                                            [attr.required]="getLabel('LBL_PickListDescription')?.isRequired ? 'required' : null"
                                            [attr.disabled]="getAuthByLabel('LBL_PickListDescription')?.canEdit ? null : 'disabled'"
                                            [readOnly]="_pageState == 1" />
                                            <a [class.editfieldsIconvisible]="_pageState == 4"
                                              class="editFieldsIcon"
                                              (click)="_openRenameForm('LBL_PickListDescription', false)">
                                              <img class="searchIcon"
                                                [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                              </a>
                                            </div>
                                          </div>
                                          <div class="transactions-stock-right-checkbox empty"></div>
                                        </div>
                                      </div>
                                    }
                                    <!-- <div *ngIf="getAuthByLabel('LBL_PickListPicked')?.canView" class="col-12 margin-top-10">
                                    <div class="form-group special_style_formgroup display-flex">
                                      <div class="row flex-1">
                                        <div class="transactions-stock-right-checkbox-text col-2">{{getLabel('LBL_PickListPicked')?.currentText}}</div>
                                        <input type="checkbox"
                                          [disabled]="_pageState === 2"
                                          class="k-checkbox"
                                          formControlName="closed"
                                          kendoCheckBox
                                          [attr.disabled]="getAuthByLabel('LBL_PickListPicked')?.canEdit ? null : 'disabled'"
                                          [attr.required]="getLabel('LBL_PickListPicked')?.isRequired ? 'required' : null" />
                                          <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                            (click)="_openRenameForm('LBL_PickListPicked')"><img class="searchIcon"
                                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"></a>
                                        </div>
                                      </div>
                                    </div> -->
                                    @if (getAuthByLabel('LBL_PickListPickedDate')?.canView && _pageState !== 2 && _form.controls['closed'].value == 'true') {
                                      <div
                                        class="col-12">
                                        <div class="form-group special_style_formgroup display-flex">
                                          <div class="row flex-1">
                                            <div class="col-2">
                                              <label class="control-label">{{getLabel('LBL_PickListPickedDate')?.currentText}}</label>
                                            </div>
                                            <div class="col-10 transaction-receive-input-fields">
                                              @if (_form.controls['closed'].value == 'true') {
                                                <kendo-datetimepicker
                                                  class="k-datepicker datepickerControlrightMargin picklist-date"
                                                  formControlName="closedDate"
                                                  placeholder="Set Date and Time"
                                                  [attr.required]="getLabel('LBL_PickListPickedDate')?.isRequired ? 'required' : null"
                                                  [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_PickListPickedDate')?.isRequired)}"
                                                  [format]="_datePickerFormat"
                                                  [disabled]="_pageState == 1">
                                                </kendo-datetimepicker>
                                              }
                                              <a [class.editfieldsIconvisible]="_pageState == 4"
                                                class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_PickListPickedDate')">
                                                <img class="searchIcon"
                                                  [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                                                  style="background-position: right; margin-left:30px" />
                                                </a>
                                              </div>
                                            </div>
                                            <div class="transactions-stock-right-checkbox empty"></div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-lg-6 small-pad-left mb-2">
                                  <div class="transactionWidget">
                                    <div class="row">
                                      <div class="col-12">
                                        <p class="titleStandardStyle">Scan Inventory ID#</p>
                                      </div>
                                      <div class="col-12 margin-top-10">
                                        <div class="form-group special_style_formgroup display-flex">
                                          <div class="row flex-1">
                                            <div class="col-2">
                                              <label class="control-label">Inventory ID#</label>
                                            </div>
                                            <div class="col-10 transaction-input-fields pl-5">
                                              <kendo-combobox #kendo_combo_inventory
                                                (opened)="scrollCombobox($event)"
                                                [disabled]=" _pageState == 1"
                                                [filterable]="true"
                                                [data]="_inventoriesFiltered"
                                                (valueChange)="_handleInventoriesChange($event)"
                                                (filterChange)="_handleInventoriesFilter($event)"
                                                [formControl]="_selectedInventoryItem"
                                                [suggest]="true"
                                                [placeholder]="'Inventory Id'"
                                                [textField]="'inventoryNumber'"
                                                [valueField]="'id'"
                                                class="bordered"
                                                required>
                                              </kendo-combobox>
                                              <span class="asap-input-icon">
                                                <img class="addIcon"
                                                  (click)="_selectInventoriesHandler()"
                                                  [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                                </span>
                                              </div>
                                            </div>
                                            <div class="transactions-stock-right-checkbox">
                                              <input type="checkbox"
                                                class="k-checkbox"
                                                [formControl]="_autoCodeGeneration"
                                                kendoCheckBox />
                                                <div class="transactions-stock-right-checkbox-text">
                                                  Quick scan
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <div class="form-group special_style_formgroup display-flex">
                                              <div class="row flex-1">
                                                <div class="col-2">
                                                  <label class="control-label">From Location</label>
                                                </div>
                                                <div class="col-10 transaction-input-fields pl-5">
                                                  <kendo-combobox #kendo_combo_from_location
                                                    [disabled]="_selectedInventoryItem.value == null || _pageState == 1"
                                                    [data]="$safeNavigationMigration(_selectedInventoryItem.value?.itemLocationsFiltered)"
                                                    [filterable]="true"
                                                    (filterChange)="_handleFromLocationsFilter($event, $safeNavigationMigration(_selectedInventoryItem.value?.itemLocationsFiltered))"
                                                    [placeholder]="'From Location'"
                                                    [textField]="'code'"
                                                    [valueField]="'id'"
                                                    [formControl]="_fromLocation"
                                                    (valueChange)="_formLocationValueChange()"
                                                    class="bordered newFormControlWidth"
                                                    required>
                                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                      <div class="transactions-dispose-stock-dropdown-item">
                                                        <div class="truncate">{{ dataItem.code }}</div>
                                                        <div class="transactions-dispose-stock-dropdown-item-description truncate">
                                                          @if (dataItem.availability) {
                                                            <span>| {{ dataItem.availability }}</span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </ng-template>
                                                  </kendo-combobox>
                                                </div>
                                              </div>
                                              <div class="transactions-receive-stock-right-checkbox">
                                                <!-- <input
                                                type="checkbox"
                                                class="k-checkbox"
                                                [formControl]="_defaultQuantity"
                                                kendoCheckBox
                                                />
                                                <div class="transactions-stock-right-checkbox-text">
                                                  Set as Default
                                                </div> -->
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <div class="form-group special_style_formgroup display-flex">
                                              <div class="row flex-1">
                                                <div class="col-2">
                                                  <label class="control-label">Available Quantity</label>
                                                </div>
                                                <div class="col-10 transaction-input-fields pl-5">
                                                  <kendo-numerictextbox [disabled]="true"
                                                    class="k-textbox writebox required"
                                                    [value]="$safeNavigationMigration(_fromLocation?.value?.availability)"
                                                    [min]="0">
                                                  </kendo-numerictextbox>
                                                </div>
                                              </div>
                                              <div class="transactions-receive-stock-right-checkbox">
                                                <!-- <input type="checkbox" class="k-checkbox" kendoCheckBox />
                                                <div class="transactions-receive-stock-right-checkbox-text">Set as Default</div> -->
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <div class="form-group special_style_formgroup display-flex">
                                              <div class="row flex-1">
                                                <div class="col-2">
                                                  <label class="control-label">Order Quantity</label>
                                                </div>
                                                <div class="col-10 transaction-input-fields pl-5">
                                                  <kendo-numerictextbox #new_quantity_input
                                                    class="k-textbox writebox required"
                                                    [formControl]="_quantity"
                                                    [max]="$safeNavigationMigration(_fromLocation?.value?.availability)"
                                                    (keyup.enter)="_quantitySubmited()"
                                                    [formControl]="_quantity"
                                                    (keydown.Tab)="_quantitySubmited()"
                                                    [min]="0"
                                                    [autoCorrect]="true"
                                                    [disabled]="_pageState == 1">
                                                  </kendo-numerictextbox>
                                                </div>
                                              </div>
                                              <div class="transactions-stock-right-checkbox">
                                                <input type="checkbox"
                                                  class="k-checkbox"
                                                  kendoCheckBox
                                                  [formControl]="_defaultQuantity" />
                                                  <div class="transactions-stock-right-checkbox-text">
                                                    Set as Default
                                                  </div>
                                                </div>
                                                <!-- <div class="transactions-receive-stock-right-checkbox">
                                                <input type="checkbox" class="k-checkbox" kendoCheckBox />
                                                <div class="transactions-receive-stock-right-checkbox-text">Set as Default</div>
                                              </div> -->
                                            </div>
                                          </div>
                                          <div class="col-12">
                                            <div class="form-group special_style_formgroup display-flex">
                                              <div class="row flex-1">
                                                <div class="col-2">
                                                  <label class="control-label"> Attached Document </label>
                                                </div>
                                                <!-- [saveUrl]="uploadSaveUrl"
                                                [removeUrl]="uploadRemoveUrl" -->
                                                <div #kendo_uploader_wrapper class="col-10 transaction-input-fields pl-5">
                                                  <kendo-upload [class.active]="true"
                                                    style="margin: 0; display: inline-block"
                                                    [class.disabled]="false"
                                                    #kendo_uploader
                                                    [batch]="false"
                                                    [autoUpload]="false"
                                                    [multiple]="true"
                                                    class="NextToLabelUpload requiredDropZone"
                                                    (select)="_fileSelectedChanges($event)"
                                                    (remove)="_fileRemoveEventHandler($event)"
                                                    formControlName="stream"
                                                    [disabled]="_pageState == 1">
                                                    <kendo-upload-messages [select]="_uploaderSelectMessage"
                                                      [dropFilesHere]="''">
                                                    </kendo-upload-messages>
                                                  </kendo-upload>
                                                  @if (_pageState != 1) {
                                                    <span class="picture-form-external-upload-btn"
                                                      (click)="_onUploadClick()">
                                                      <img [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                                    </span>
                                                  }
                                                  @if (_pageState != 1) {
                                                    <a (click)="_showDocumentsGrid=true"
                                                      class="asap-input-icon">
                                                      <img _ngcontent-sqy-c791="" class="addIcon"
                                                        [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                                                      </a>
                                                    }
                                                  </div>
                                                </div>
                                                <div class="transactions-receive-stock-right-checkbox noprint"
                                                  [class.notempty]="_settingsPrintReceipt && _settingsPrintReceipt.enabled">
                                                  @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                                                    <input type="checkbox"
                                                      class="k-checkbox newFormControlWidth"
                                                      kendoCheckBox
                                                      [formControl]="_printReceipt"
                                                      />
                                                  }
                                                  @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                                                    <div class="transactions-stock-right-checkbox-text"
                                                      >
                                                      Print Receipt
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="example-wrapper">
                                      <div class="row no_row_margin">
                                        <div class="col-12 col-lg-9 col-xl-10 responsive_style numericboxtab"
                                          #kendo_tabstrip_wrapper
                                          [class.ossystem]="_isOs">
                                          <kendo-tabstrip (tabSelect)="_onTabSelect($event)"
                                            [tabPosition]="_kendoTabStripPosition">
                                            @for (tab of _dataTabs; track tab) {
                                              @if (tab.name == 'General') {
                                                <kendo-tabstrip-tab #GeneralTab
                                                  title="General"
                                                  [selected]="true">
                                                  <ng-template kendoTabContent>
                                                    <div class="greytabtop menumobilecontainer">
                                                      <img class="mobiletabIcon"
                                                        (click)="_mobileMenuToggle()"
                                                        [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                                      </div>
                                                      <div class="tabcontent p-0">
                                                        <fieldset class="contenttabstyle">
                                                          <!-- <h2 class="tabcontentTitle">General</h2> -->
                                                          <div class="col-12 p-0">
                                                            <div class="with-grid numericboxtab">
                                                              <div class="flex-space-between transaction-grid-header-wrapper">
                                                                <p class="titleStandardStyle">Selected Items</p>
                                                                <div class="transaction-grid-top-actions">
                                                                  <div class="transaction-grid-top-actions-radio">
                                                                    <input type="radio"
                                                                      id="new-to-old-items"
                                                                      name="transaction-duration"
                                                                      value="new"
                                                                      [formControl]="_sortingSelected"
                                                                      kendoRadioButton />
                                                                      <label class="k-radio-label"
                                                                      [for]="'new-to-old-items'">Newest To Oldest</label>
                                                                    </div>
                                                                    <div class="transaction-grid-top-actions-radio">
                                                                      <input type="radio"
                                                                        id="old-to-new-items"
                                                                        name="transaction-duration"
                                                                        value="old"
                                                                        [formControl]="_sortingSelected"
                                                                        kendoRadioButton />
                                                                        <label class="k-radio-label"
                                                                        [for]="'old-to-new-items'">Oldest To Newest</label>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <kendo-grid [data]="_inventoryGridData"
                                                                    [scrollable]="'none'"
                                                                    class="transaction-grid"
                                                                    (remove)="_removeHandler($event)">
                                                                    <kendo-grid-column field="inventoryCode"
                                                                      title="Inventory ID#">
                                                                    </kendo-grid-column>
                                                                    <kendo-grid-column field="itemNumber"
                                                                      title="Stock#">
                                                                    </kendo-grid-column>
                                                                    <kendo-grid-column field="description"
                                                                      title="Description">
                                                                    </kendo-grid-column>
                                                                    <!-- <kendo-grid-column
                                                                    field="fromlocation"
                                                                    title="From Location"
                                                                    >
                                                                  </kendo-grid-column> -->
                                                                  <kendo-grid-column field="fromlocation" title="From Location">
                                                                    <ng-template kendoGridCellTemplate let-dataItem>
                                                                      <kendo-combobox #kendo_combo_locations
                                                                        style="width: 100%"
                                                                        [data]="dataItem.itemLocations"
                                                                        [filterable]="true"
                                                                        (filterChange)="_handleFromLocationsFilter($event, dataItem)"
                                                                        (valueChange)="_handleFromLocationChange($event, dataItem)"
                                                                        [(ngModel)]="dataItem.selectedLocation"
                                                                        [ngModelOptions]="{standalone: true}"
                                                                        [suggest]="true"
                                                                        [disabled]="dataItem.stockItem.itemType.id == 2 ||  _pageState == 1"
                                                                        [placeholder]="'Choose a Location'"
                                                                        [textField]="'code'"
                                                                        [valueField]="'id'"
                                                                        class="bordered">
                                                                      </kendo-combobox>
                                                                    </ng-template>
                                                                  </kendo-grid-column>
                                                                  <kendo-grid-column field="availableQty"
                                                                    title="Available Quantity">
                                                                  </kendo-grid-column>
                                                                  <kendo-grid-column title="Order Quantity"
                                                                    field="orderQty">
                                                                    <ng-template kendoGridCellTemplate
                                                                      let-dataItem>
                                                                      <kendo-numerictextbox class="PO-grid-quantity"
                                                                        [value]="dataItem.orderQty"
                                                                        (valueChange)="_onOrderQuantityChange($event, dataItem)"
                                                                        [min]="0"
                                                                        [autoCorrect]="true"
                                                                        [disabled]="dataItem.stockItem.itemType.id == 2 || _pageState == 1"
                                                                        [max]="dataItem.availableQty"
                                                                        [(ngModel)]="dataItem.orderQty"
                                                                        [ngModelOptions]="{standalone: true}">
                                                                      </kendo-numerictextbox>
                                                                    </ng-template>
                                                                  </kendo-grid-column>
                                                                  <!-- <kendo-grid-column
                                                                  field="orderQty"
                                                                  title="Order Quantity"
                                                                  >
                                                                </kendo-grid-column> -->
                                                                <!-- <kendo-grid-column
                                                                field="uomcode"
                                                                title="UOM Code"
                                                                >
                                                              </kendo-grid-column> -->
                                                              <kendo-grid-command-column title="Action">
                                                                <ng-template kendoGridCellTemplate>
                                                                  @if (_pageState != 1) {
                                                                    <div kendoGridRemoveCommand
                                                                      class="asap-grid-remove"
                                                                      >
                                                                      <div class="asap-grid-remove-icon">
                                                                        <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                                      </div>
                                                                      <div class="asap-grid-remove-text">
                                                                        Delete
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                </ng-template>
                                                              </kendo-grid-command-column>
                                                            </kendo-grid>
                                                          </div>
                                                        </div>
                                                        <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                          [pageState]="_pageState"
                                                          [accounts]="_selectedAccountIds"
                                                          [formName]="'stock'"
                                                          page="pickList"
                                                          [invalidSubmit]="_invalidSubmit"
                                                          (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                          (customFieldsDeleteValue)="_removeCustomField($event)"
                                                          (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                          (customFieldsStatus)="formStatus($event)"
                                                          [_customFieldsValue]="_customFieldsValue">
                                                        </asap-custom-fields-form>
                                                        <div class="form-group special_style_formgroup">
                                                          <button kendobutton
                                                            class="addNewFieldButton k-button"
                                                            (click)="_addNewField(tab.id)">
                                                            <img class="backimage"
                                                              src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                            </button>
                                                          </div>
                                                        </fieldset>
                                                      </div>
                                                    </ng-template>
                                                  </kendo-tabstrip-tab>
                                                }
                                                @if (tab.isCustom) {
                                                  <kendo-tabstrip-tab [title]="tab.name">
                                                    <ng-template kendoTabContent>
                                                      <div class="tabcontent">
                                                        <fieldset class="contenttabstyle margin-top-10">
                                                          <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                            [pageState]="_pageState"
                                                            [accounts]="_selectedAccountIds"
                                                            [formName]="'stock'"
                                                            page="pickList"
                                                            [invalidSubmit]="_invalidSubmit"
                                                            (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                            (customFieldsDeleteValue)="_removeCustomField($event)"
                                                            (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                            (customFieldsStatus)="formStatus($event)"
                                                            [_customFieldsValue]="_customFieldsValue">
                                                          </asap-custom-fields-form>
                                                          <div class="form-group special_style_formgroup">
                                                            <button kendobutton
                                                              class="addNewFieldButton k-button"
                                                              (click)="_addNewField(tab.id)">
                                                              <img class="backimage"
                                                                src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                              </button>
                                                            </div>
                                                            <div class="form-group special_style_formgroup">
                                                              <button kendobutton
                                                                class="addNewFieldButton k-button"
                                                                (click)="_deactivateTab(tab.id, 'pickList')">
                                                                <img class="backimage"
                                                                  src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                                </button>
                                                              </div>
                                                            </fieldset>
                                                          </div>
                                                        </ng-template>
                                                      </kendo-tabstrip-tab>
                                                    }
                                                  }
                                                </kendo-tabstrip>
                                              </div>
                                              <div class="col-12 col-lg-3 col-xl-2 responsive_style">
                                                <div class="borderedNotesContainer">
                                                  <note #note
                                                    [_pageState]="_pageState"
                                                    [_model]="_model"
                                                  [_page]="_page"></note>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row no_row_margin">
                                              <div class="col-12">
                                                <button kendobutton
                                                  class="addNewtabButton k-button"
                                                  (click)="_addNewTab()">
                                                  <img class="backimage"
                                                    src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                                  </button>
                                                </div>
                                              </div>
                                              <div class="row no_row_margin">
                                                <div class="col-12">
                                                  <button kendobutton
                                                    class="reorderTabButton k-button"
                                                    (click)="_reorderingtabs()">
                                                    <img class="backimage"
                                                      src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div class="row no_row_margin">
                                                  <div class="col-12">
                                                    <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                                      Notes:
                                                    </p>
                                                    <p class="tabsMap">
                                                      Tabs with <span>*</span> contains Mandatory fields
                                                    </p>
                                                    <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                                      You can Drag and Drop Fields to reorder by clicking on this image
                                                      <img class="reorder_image"
                                                        [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              <!-- </div> -->
                                              <div class="row">
                                                <div class="col-12">
                                                  @if (_invalidForm) {
                                                    <asap-forms-validation-summary
                                                      [form]="_form"
                                                      [page]="'pickList'">
                                                    </asap-forms-validation-summary>
                                                  }
                                                </div>
                                              </div>
                                              @if (_barcodePopupActive || showReports || _editFormActive || _isEditForms || _showInventoriesGrid
                                                || _orderingTabsForm || _deactivatedFieldsForm || _editFormActive || _isDialiog || _showDocumentsGrid) {
                                                <div class="k-overlay"
                                                ></div>
                                              }
                                            </form>
                                            @if (false) {
                                              <kendo-window>
                                                <div class="row zeromarginRow">
                                                  <div class="col-12 col-lg-6 zeroPaddingColumn">
                                                    <div class="row zeromarginRow">
                                                      <div class="col-12 margin-top-10 zeroPaddingColumn">
                                                        <div class="form-group special_style_formgroup">
                                                          <div class="row zeromarginRow">
                                                            <div class="col-2">
                                                              <label class="control-label">Receive Receipt</label>
                                                            </div>
                                                            <div class="col-10 transaction-receive-input-fields">
                                                              <kendo-combobox #kendo_combo_Receipt_Report
                                                                [data]="receiveReports"
                                                                [suggest]="true"
                                                                class="bordered newFormControlWidth"
                                                                [textField]="'name'"
                                                                [valueField]="'id'"
                                                                placeholder="Select Receive Print Receipt">
                                                              </kendo-combobox>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 margin-top-10 zeroPaddingColumn">
                                                    <button kendoButton
                                                      class="steps_buttons_class"
                                                      (click)="_printReceiptReport()">
                                                      <img class="backimage"
                                                        [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                                        <span>Print</span>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </kendo-window>
                                              }
                                            </kendo-window>
                                          }
                                          @if (_isDialiog) {
                                            <asap-dialog-layout
                                              [data]="_dialogModel"
                                              [componentName]="_dialogComponentName"
                                              (closeDialog)="_closeDialog($event)">
                                            </asap-dialog-layout>
                                          }
                                          @if (_editFormActive) {
                                            <kendo-window
                                              title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                                              (close)="_closeCustomFields()"
                                              class="customFieldsWindow">
                                              <asap-custom-fields [accounts]="_selectedAccountIds"
                                                [tabGroup]="_selectedTabId"
                                                [labelId]="_selectedLabelId"
                                                [labelObjectCode]="_selectedLabelObjectCode"
                                                [formName]="'stock'"
                                                page="pickList"
                                                [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                                [isCustomtabsForm]="_isAddTabFormValue"
                                                [isRenameForm]="_isRenameFormValue"
                                                [language]="_language"
                                                [isRenameCustomForm]="_isRenameCustomFormValue"
                                                [isRenameLabel]="_isRenameLabel"
                                                [isMandatory]="_isMandatory"
                                                (closePopup)="ClosePopup($event)"
                                                [permissionScope]="_permissionScope">
                                              </asap-custom-fields>
                                            </kendo-window>
                                          }
                                          @if (_deactivatedFieldsForm) {
                                            <kendo-window
                                              title="Deactivated Fields"
                                              (close)="_closeInactiveFields()">
                                              <div class="row no_row_margin margin-top-30">
                                                <div class="col-12 margin-top-10">
                                                  <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                                    <kendo-grid-column field="name" title="Fields Name">
                                                    </kendo-grid-column>
                                                    <kendo-grid-column field="formTab.name" title="Tab Name">
                                                    </kendo-grid-column>
                                                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                                      <ng-template kendoGridCellTemplate let-dataItem>
                                                        {{dataItem.createdOn | dateFormat}}
                                                      </ng-template>
                                                    </kendo-grid-column>
                                                    <kendo-grid-column field="lastUpdatedOn"
                                                      title="Deactivation Date"
                                                      type="date">
                                                      <ng-template kendoGridCellTemplate let-dataItem>
                                                        {{dataItem.lastUpdatedOn | dateFormat}}
                                                      </ng-template>
                                                    </kendo-grid-column>
                                                    <kendo-grid-column field="Command" title="Command">
                                                      <ng-template kendoGridCellTemplate let-dataItem>
                                                        <div class="action-button action-button-deactivate"
                                                          (click)="_reactivate(dataItem)">
                                                          <div class="action-button-icon">
                                                            <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                                          </div>
                                                          <div class="edit-icon-text">Reactivate</div>
                                                        </div>
                                                      </ng-template>
                                                    </kendo-grid-column>
                                                  </kendo-grid>
                                                </div>
                                              </div>
                                            </kendo-window>
                                          }
                                          @if (_orderingTabsForm) {
                                            <kendo-window
                                              title="Tab Reordering"
                                              (keydown.enter)="$event.preventDefault()"
                                              (close)="_closeOrderingTabsForm()">
                                              <div class="row no_row_margin margin-top-30">
                                                @if (false) {
                                                  <div class="col-12 margin-top-10">
                                                    <div class="form-group">
                                                      <label for="itemType" class="control-label">Tab 1</label>
                                                      <kendo-combobox [data]="_dataTabsSelected"
                                                        [suggest]="true"
                                                        [textField]="'name'"
                                                        [valueField]="'name'"
                                                        placeholder="Accounts/Sites"
                                                        class="newFormControlWidth disabled">
                                                      </kendo-combobox>
                                                    </div>
                                                  </div>
                                                }
                                                @for (item of _dataTabs ; track item; let i = $index) {
                                                  <div class="col-12 margin-top-10">
                                                    <div class="form-group">
                                                      <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                                      <kendo-combobox [data]="_dataTabsSelected"
                                                        [suggest]="true"
                                                        [textField]="'name'"
                                                        [valueField]="'name'"
                                                        [placeholder]="item.name"
                                                        required
                                                        class="bordered newFormControlWidth"
                                                        (valueChange)="_comboValueChange($event,i)">
                                                      </kendo-combobox>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                              <div class="row no_row_margin">
                                                <div class="col-12">
                                                  <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                                                    <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                                    <span>save & Close</span>
                                                  </button>
                                                </div>
                                              </div>
                                            </kendo-window>
                                          }
                                          @if (_showInventoriesGrid) {
                                            <kendo-window title="Add Inventory to Picklist" (close)="_closeInventoriesWindow()" class="addFromLibrary">
                                              <div class="greytabtop">
                                                <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedStocksHandler($event)">
                                                  Select & Return
                                                </button>
                                              </div>
                                              @if (_inventoryItemsGridColumns) {
                                                <asap-grid-layout
                                                  [page]="'inventories'"
                                                  [entityName]="'inventory'"
                                                  [sortingEnabled]="true"
                                                  [singleSelect]="false"
                                                  [enableSiteSelection]="false"
                                                  [resolver]="_getInventoryItems"
                                                  class="ListGrid"
                                                  [selectable]="true"
                                                  [orderEnable]="true"
                                                  [pagingEnabled]="true"
                                                  [selectByField]="_selectedCallback"
                                                  [filteringEnable]="true"
                                                  [DisableDestory]="false"
                                                  [addNewFormEnabled]="false"
                                                  [deletedEnabled]="false"
                                                  [headerEnable]="true"
                                                  [groupingEnabled]="true"
                                                  (onRowSelectionChanges)="_onStockRowSelectionChanges($event)">
                                                  <!-- <ng-container *ngFor="let column of _inventoryItemsGridColumns">
                                                  <ng-container *ngIf="column.selected">
                                                    <ng-container *ngIf="column.isTemplate">
                                                      <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                        let-item>
                                                        <ng-container *ngIf="column.field == 'stockItem.itemType.name'">
                                                          {{item.stockItem.itemType?.name}}
                                                        </ng-container>
                                                        <ng-container
                                                          *ngIf="column.field == 'stockItem.receiveUnitOfMeasure.code'"
                                                          >
                                                          {{item.stockItem.receiveUnitOfMeasure?.code}}
                                                        </ng-container>
                                                        <ng-container
                                                          *ngIf="column.field == 'stockItem.receiveUnitOfMeasure.multiplier'"
                                                          >
                                                          {{item.stockItem.receiveUnitOfMeasure?.multiplier}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'stockItem.costType.code'">
                                                          {{item.stockItem.costType?.code}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'stockItem.number'">
                                                          {{item.stockItem.number}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'availability'">
                                                          {{item.availability}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'location.code'">
                                                          {{item.location?.code}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'site.account.name'">
                                                          {{item.site.account?.name}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'site.name'">
                                                          {{item.site?.name}}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.field == 'entryDate'">
                                                          {{item.entryDate}}
                                                        </ng-container>
                                                      </ng-template>
                                                    </ng-container>
                                                    <ng-container *ngIf="!column.isTemplate">
                                                      <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                        let-item>
                                                        <ng-container *ngIf="column.type == 'date'">
                                                          {{ item[column.field] | dateFormat }}
                                                        </ng-container>
                                                        <ng-container *ngIf="column.type != 'date'">
                                                          {{item[column.field]}}
                                                        </ng-container>
                                                      </ng-template>
                                                    </ng-container>
                                                  </ng-container>
                                                </ng-container> -->
                                                <!-- <ng-container *ngFor="let column of _inventoryItemsGridColumns">
                                                <ng-container *ngIf="column.selected">
                                                  <ng-container *ngIf="column.isTemplate">
                                                    <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                      let-item>
                                                      <ng-container *ngIf="column?.type == 'date'">
                                                        {{ getPropByString(item,column.field) | dateFormat }}
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="column.field == 'stock.extendedCost'"
                                                        >
                                                        {{((item.stockItem?.costInfo?.cost /
                                                        item.stockItem?.receiveUnitOfMeasure?.multiplier) *
                                                        item.stockItem?.inventoryUnitOfMeasure?.multiplier *
                                                        item.availability) | costFormat}}
                                                      </ng-container>
                                                      <ng-container
                                                        *ngIf="column.field == 'stock.inventoryCost'"
                                                        >
                                                        {{((item.stockItem?.costInfo?.cost /
                                                        item.stockItem?.receiveUnitOfMeasure?.multiplier) *
                                                        item.stockItem?.inventoryUnitOfMeasure?.multiplier) | costFormat}}
                                                      </ng-container>
                                                      <ng-container *ngIf="column?.type != 'date' || column.type==null  "> && column.field != 'quantityPerAccount' -->
                                                        <!-- {{item[column.field]}}
                                                        {{getPropByString(item,column.field)}}
                                                      </ng-container>
                                                    </ng-template>
                                                  </ng-container> -->
                                                  <!-- <ng-container *ngIf="!column.isTemplate">
                                                  <ng-template
                                                    pageListColumn
                                                    [field]="column.field"
                                                    [name]="column.title"
                                                    [type]="column.type"
                                                    let-item
                                                    >
                                                    <ng-container *ngIf="column.type === 'date'">
                                                      {{item[column.field] !== null ? ( item[column.field] | dateFormat )
                                                      : '' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="column.type != 'date'">
                                                      {{ item[column.field] != null ? item[column.field] : '' }}
                                                    </ng-container>
                                                    <ng-container
                                                      *ngIf="column.type == 'date' && column.field.split('.').length  == 2"
                                                      >
                                                      {{item[column.field?.split('.')[0]] !== null &&
                                                      item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                      null ? (item[column.field?.split('.')[0]]
                                                      [column.field?.split('.')[1]] | dateFormat ): '' }}
                                                    </ng-container>
                                                    <ng-container
                                                      *ngIf="column.type == 'date' && column.field?.split('.').length  == 3"
                                                      >
                                                      {{item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                      !== null && item[column.field?.split('.')[0]]
                                                      [column.field?.split('.')[1]][column.field?.split('.')[2]] !== null?
                                                      (item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                      [column.field?.split('.')[2]] | dateFormat ) : '' }}
                                                    </ng-container>
                                                    <ng-container
                                                      *ngIf="column.type != 'date' &&  column.field.split('.').length  == 2"
                                                      >
                                                      {{item[column.field?.split('.')[0]] !== null &&
                                                      item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                      null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                      : '' }}
                                                    </ng-container>
                                                    <ng-container
                                                      *ngIf="column.type != 'date' && column.field.split('.').length == 3 "
                                                      >
                                                      {{item[column.field?.split('.')[0]] !== null &&
                                                      item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
                                                      null && item[column.field?.split('.')[0]]
                                                      [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
                                                      ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                      [column.field?.split('.')[2]] : ''}}
                                                    </ng-container>
                                                  </ng-template>
                                                </ng-container> -->
                                                @for (column of _inventoryItemsGridColumns; track column) {
                                                  @if (column.selected) {
                                                    @if (column.isTemplate) {
                                                      <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                        let-item>
                                                        @if (column?.type == 'date') {
                                                          {{ item[column.field] | dateFormat }}
                                                        }
                                                        @if (column.field == 'stock.extendedCost') {
                                                          {{
                                                          (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                                                          $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) *
                                                          $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier) *
                                                          item.availability) | costFormat
                                                          }}
                                                        }
                                                        @if (column.field == 'stock.inventoryCost') {
                                                          {{
                                                          (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                                                          $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) *
                                                          $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier)) | costFormat
                                                          }}
                                                        }
                                                        @if (column?.type != 'date' || column.type==null  ) {
                                                          {{column.field | complexFieldValue: item}}
                                                        }
                                                        @if (column.isCustomField == true) {
                                                          {{item[column.field]}}
                                                        }
                                                      </ng-template>
                                                    }
                                                    @if (!column.isTemplate ) {
                                                      <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                        let-item>
                                                        @if (column.type == 'date') {
                                                          {{ item[column?.field] | dateFormat }}
                                                        }
                                                        @if (column.type != 'date'  || column.type==null ) {
                                                          {{column.field | complexFieldValue: item}}
                                                        }
                                                        @if (column.isCustomField == true) {
                                                          {{item[column.field]}}
                                                        }
                                                      </ng-template>
                                                    }
                                                  }
                                                }
                                                <!-- <ng-container *ngIf="!column.isTemplate ">
                                                <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                                                  let-item>
                                                  <ng-container *ngIf="column.type == 'date'">
                                                    {{ getPropByString(item,column.field) | dateFormat }}
                                                  </ng-container>
                                                  <ng-container *ngIf="column.type != 'date'  || column.type==null ">&& column.field != 'quantityPerAccount'
                                                    {{item[column?.field]}} -->
                                                    <!-- {{getPropByString(item,column.field)}}
                                                  </ng-container>
                                                </ng-template>
                                              </ng-container> -->
                                            </asap-grid-layout>
                                          }
                                        </kendo-window>
                                      }
                                      @if (_isEditForms) {
                                        <asap-edit-forms
                                          (close)="_onCloseEditForms($event)"
                                          (saved)="_closeCustomFields()"
                                          [page]="_page"
                                          [permissionScope]="_permissionScope">
                                        </asap-edit-forms>
                                      }
                                      @if (_editFormActive) {
                                        <kendo-window
                                          title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                                          (close)="_closeCustomFields()"
                                          class="customFieldsWindow">
                                          <asap-custom-fields [accounts]="_selectedAccountIds"
                                            [tabGroup]="_selectedTabId"
                                            [labelId]="_selectedLabelId"
                                            [labelObjectCode]="_selectedLabelObjectCode"
                                            [formName]="'stock'"
                                            page="pickList"
                                            [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                            [isCustomtabsForm]="_isAddTabFormValue"
                                            [isRenameForm]="_isRenameFormValue"
                                            [language]="_language"
                                            [isRenameCustomForm]="_isRenameCustomFormValue"
                                            [isRenameLabel]="_isRenameLabel"
                                            [isMandatory]="_isMandatory"
                                            (closePopup)="ClosePopup($event)"
                                            [permissionScope]="_permissionScope">
                                          </asap-custom-fields>
                                        </kendo-window>
                                      }
                                      @if (_showDocumentsGrid) {
                                        <kendo-window
                                          title="Add Document(s) to Picklist"
                                          (close)="_closeDocumentsWindow()"
                                          class="addFromLibrary">
                                          <div class="greytabtop">
                                            <button kendoButton
                                              class="topRightButtonSelect"
                                              (click)="_returnSelectedDocumentsHandler($event)">
                                              Select & Return
                                            </button>
                                          </div>
                                          <asap-grid-layout [selectable]="true"
                                            [pagingEnabled]="true"
                                            [selectByField]="'id'"
                                            [selectByFieldTitle]="'Select Document'"
                                            [enableSiteSelection]="false"
                                            [filteringEnable]="true"
                                            [selectedKeys]="_selectedDocumentsKeys"
                                            [resolver]="_getAccountDocuments"
                                            [orderEnable]="true"
                                            [sortingEnabled]="true"
                                            (onRowSelectionChanges)="_onDocumentRowSelectionChanges($event)"
                                            (onRowObjectSelectionChanges)="_onDocumentbjectRowSelectionChanges($event)">
                                            <ng-template pageListColumn name="Name" field="name" let-item>
                                              {{item.name}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Description" field="description" let-item>
                                              {{item.description}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Type" field="type" let-item>
                                              {{item.type}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Stream" let-item>
                                              <img src="{{ item.stream }}" alt="{{ item.name }}" width="50" />
                                            </ng-template>
                                          </asap-grid-layout>
                                        </kendo-window>
                                      }
                                      @if (_showDocumentsGrid || _barcodePopupActive || showReports || _showInventoriesGrid  ||
                                        _editFormActive || _active || _isEditForms) {
                                        <div class="k-overlay"
                                        ></div>
                                      }
